module.exports = __webpack_public_path__ + "static/media/04062021_text_message_140px.43135b95.svg";